<template>
<div class="site-detail">
    <Error @reload="getData()" v-if="networkError" />
    <div class="intro-page" v-else-if="showPage">
        <v-banner :site="site" />
        <div class="intro-wrapper">
            <div class="intro-brief">
                <div class="intro-name">{{ site.name }}</div>
                <div class="place-rate" v-if="site.rating || site.reviews">
                    <Score :rating="site.rating" v-if="site.rating" />
                    <div class="place-review" v-if="site.reviews">{{ site.reviews }} {{ $t('home.comment') }}</div>
                </div>
            </div>
            <v-detail-content :detailArray="guideArray"
                              :site="site"
                              siteType="site" />
        </div>
        <div class="explore-around">
            <v-explore-list :sites="site.sites" :hotels="site.hotels" :merchants="site.merchants" />
        </div>
    </div>
</div>
</template>

<script>
import { getScenicDetail } from '@/fetch/api'
import { GetDistance, formatMinutes } from '@/utils/index'
import Error from '@/components/Error.vue'
import Score from '@/components/Score.vue'
import DetailContent from '@/components/scenic/DetailContent.vue'
import Banner from '@/components/scenic/Banner.vue'
import ExploreList from '@/components/scenic/ExploreList.vue'

export default {
    data () {
        return {
            siteId: '1',
            showPage: false,
            id: '',
            site: {},
            guideArray: [],
            networkError: false
        }
    },
    components: {
        Error,
        Score,
        'v-detail-content': DetailContent,
        'v-banner': Banner,
        'v-explore-list': ExploreList
    },
    created () {
        document.title = this.$t('poi.siteTitle')
        this.toast = this.$createToast({
            time: 0,
            txt: this.$t('common.loadingMsg'),
            mask: true
        })
        this.toast.show()
        navigator.geolocation.getCurrentPosition((res) => {
            const longitude = res.coords.longitude
            const latitude = res.coords.latitude
            this.geoData = {
                lon: longitude,
                lat: latitude
            }
            // console.log(longitude, latitude)
            if (longitude) {
                this.getData()
            }
        }, err => {
            this.geoData = {
                lon: 103.82241,
                lat: 1.2651
            }
            this.getData()
        }, { timeout: 5000, enableHighAccuracy: true })
    },
    watch: {
        '$route' () {
            this.getData()
        }
    },
    methods: {
        getData () {
            const params = {
                lon: this.geoData.lon,
                lat: this.geoData.lat
            }
            if (this.$route.query.language === 'zh') {
                params.locale = 'cn'
            } else {
                params.locale = 'en'
            }
            getScenicDetail(this.$route.params.id, params).then(res => {
                let distance = GetDistance(this.geoData.lat, this.geoData.lon, res.lat, res.lon)
                this.networkError = false
                this.site = { ...res, distance }
                this.guideArray = this.processGuide(res)
                this.showPage = true
                this.toast.hide()
                window.scrollTo(0,0)
            }).catch(err => {
                console.log(err)
                this.toast.hide()
                this.networkError = true
            })
        },
        processGuide (site) {
            let guideArray = []
            if (site.description) {
                guideArray.push({
                    id: 'description',
                    text: this.$t('poi.siteDesc'),
                    content: site.description
                })
            }
            if (site.operation_time) {
                guideArray.push({
                    id: 'time',
                    text: this.$t('poi.siteTime'),
                    content: site.operation_time
                })
            }
            if (site.contact_number) {
                guideArray.push({
                    id: 'number',
                    text: this.$t('poi.number'),
                    content: site.contact_number
                })
            }
            if (site.website) {
                guideArray.push({
                    id: 'website',
                    text: this.$t('poi.website'),
                    content: site.website
                })
            }
            if (site.traffic_strategy) {
                guideArray.push({
                    id: 'traffic',
                    text: this.$t('poi.traffic'),
                    content: site.traffic_strategy
                })
            }
            if (site.ticket_strategy) {
                guideArray.push({
                    id: 'ticket',
                    text: this.$t('poi.ticket'),
                    content: site.ticket_strategy
                })
            }
            if (site.visiting_time) {
                guideArray.push({
                    id: 'recommend',
                    text: this.$t('poi.recommend'),
                    content: formatMinutes(site.visiting_time)
                })
            }
            if (site.address) {
                guideArray.push({
                    id: 'address',
                    text: this.$t('poi.address'),
                    content: site.address
                })
            }
            return guideArray
        },
    }
}
</script>

<style lang="scss" scoped>
.intro-page {
    margin-bottom: env(safe-area-inset-bottom);
}

.intro-page.from-trip {
    padding-bottom: 160rpx;
}

.intro-page.rws {
    padding-bottom: 140rpx;
}

.intro-page.from-trip.rws {
    padding-bottom: 244rpx;
}
</style>